export default "__VITE_ASSET__f8617470__"